import { render, staticRenderFns } from "./SmsMailing.vue?vue&type=template&id=20d1706a"
import script from "./SmsMailing.vue?vue&type=script&lang=js"
export * from "./SmsMailing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports